/* eslint-disable max-len */
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DorMeasurementFieldNames, DorPlaceStatus } from '@powdr/constants';
import { getPlaces } from '@powdr/stores';
import { filterLiftTrailItemsBySeason } from '@powdr/utils';

export const usePlacesMeasurements = (season) => {
  const dispatch = useDispatch();
  const usePlacesData = useSelector((state) => state.places);
  const { data } = usePlacesData;
  const [placesData, setPlacesData] = useState(null);

  useEffect(() => {
    dispatch(getPlaces());
  }, [dispatch]);

  useEffect(() => {
    if (data && data?.length > 0) {
      setPlacesData({
        [DorMeasurementFieldNames.OPEN]: filterLiftTrailItemsBySeason(
          data.filter((l) => (l.status === DorPlaceStatus.OPEN.name)),
          season,
        ).length,
        [DorMeasurementFieldNames.TOTAL]: filterLiftTrailItemsBySeason(
          data,
          season,
        ).length,
      });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return placesData;
};
